import React, { useEffect, useState } from 'react';
import { bookMarkCourse, favCourses } from '../../api/apiHandler';
import { Loading } from '../../components/loading/loading';
import { showPromiseNotification } from '../../common/notification';
import ReactPaginate from "react-paginate";
import { Link } from 'react-router-dom';
import { encryption } from '../../common/enc_dec';
import { useTranslation } from 'react-i18next';
import '../../i18';

const FavouriteCourses = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [courses, setCourses] = useState([]);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    let debounceTimer = null;

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                await getFavCourse();
            } catch (error) {
                console.error('Failed to fetch course data:', error);
            }
            setIsLoading(false);
        };
        fetchData();
    }, []);

    const getFavCourse = async () => {
        const response = await favCourses({
            page: pageToken,
            limit: 6
        });
        if (response.code === 200 || response.code === 404) {
            setCourses(response.data?.data);
            setTotalPage(response.data.paging);
        }
    };

    const handleBookmark = async (courseId) => {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        debounceTimer = setTimeout(async () => {
            const myPromise = new Promise(async (resolve, reject) => {
                const response = await bookMarkCourse({ course_id: courseId });
                if (response?.code === 200) {
                    getFavCourse();
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            showPromiseNotification(myPromise);
        }, 300);
    };

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    };

    if (isLoading) {
        return <Loading />;
    }

    return (
        <section className="course-single-area pd-top-120 pd-bottom-90">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="CartMainBox">
                            <h2 className="CartHeading">{t('favCoursesHeading')}</h2>
                        </div>
                    </div>
                    {courses && courses.length > 0 && courses.map((courseData) => (
                        <div key={courseData.id} className="col-lg-4 col-md-6 CourseGride">
                            <div className="single-course-inner">
                                {!courseData?.is_expired ? (
                                    <>
                                        <Link to={
                                            courseData?.is_purchage
                                                ? courseData.is_test_completed === false && courseData.is_expired === false
                                                    ? `/start-course/${encodeURIComponent(
                                                        encryption(
                                                            {
                                                                course_id: courseData?.course_id,
                                                                category_id: courseData?.user_favorite_course?.category_id,
                                                                language: courseData?.user_favorite_course?.language,
                                                                is_completed: courseData?.is_completed
                                                            },
                                                            true
                                                        )
                                                    )}`
                                                    : '/course'
                                                : `/course-details/${encodeURIComponent(encryption({
                                                    id: courseData?.course_id, category_id: courseData?.user_favorite_course?.category_id, language: courseData?.user_favorite_course?.language
                                                }, true))}`}
                                            state={
                                                courseData?.is_purchage && courseData?.is_test_completed
                                                    ? { tab: 'completed' }
                                                    : undefined}
                                            className="thumb">
                                            <img src={courseData.user_favorite_course.image} alt={courseData.user_favorite_course.name} />
                                        </Link>
                                    </>
                                ) : (
                                    <div className="thumb" style={{ position: "relative" }}>
                                        <img src={courseData?.user_favorite_course?.image} alt="course" />
                                        {courseData.is_expired && (
                                            <span className='expire-course'>{t('expired')}</span>
                                        )}
                                    </div>
                                )}
                                <div className="details">
                                    {!courseData?.is_expired ? (
                                        <>
                                            <Link to={
                                                courseData?.is_purchage
                                                    ? courseData.is_test_completed === false && courseData.is_expired === false
                                                        ? `/start-course/${encodeURIComponent(
                                                            encryption(
                                                                {
                                                                    course_id: courseData?.course_id,
                                                                    category_id: courseData?.user_favorite_course?.category_id,
                                                                    language: courseData?.user_favorite_course?.language,
                                                                    is_completed: courseData?.is_completed
                                                                },
                                                                true
                                                            )
                                                        )}`
                                                        : '/course'
                                                    : `/course-details/${encodeURIComponent(encryption({
                                                        id: courseData?.course_id, category_id: courseData?.user_favorite_course?.category_id, language: courseData?.user_favorite_course?.language
                                                    }, true))}`}
                                                state={
                                                    courseData?.is_purchage && courseData?.is_test_completed
                                                        ? { tab: 'completed' }
                                                        : undefined}
                                                className="details-inner">
                                                <div className="d-flex justify-content-between mb-3">
                                                    <p className="CardMainHeading">{courseData?.user_favorite_course?.course_category?.name}</p>
                                                    {courseData?.user_favorite_course?.assign_trainer?.length > 0 && (
                                                        <div className="emt-user">
                                                            <span className="u-thumb">
                                                                <img src={courseData?.user_favorite_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="User" />
                                                            </span>
                                                            <span className="align-self-center">{courseData?.user_favorite_course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <h6 className="CardMainSubHeading">
                                                    {courseData?.user_favorite_course?.name}
                                                </h6>
                                                <div className="LassonsMain">
                                                    <ul className="LassonsUl">
                                                        <li className="LassonsLi">
                                                            <p className="Lessonstext">{courseData.user_favorite_course.total_lession} {t('lessons')}</p>
                                                        </li>
                                                        <li className="dots" />
                                                        <li className="LassonsLi">
                                                            <p className="Lessonstext">{courseData.user_favorite_course.duration}</p>
                                                        </li>
                                                        <li className="dots" />
                                                        <li className="LassonsLi">
                                                            <p className="Lessonstext">
                                                                <strong>{courseData.user_favorite_course.validity}</strong> {t('daysValidity')}
                                                            </p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </Link>
                                        </>
                                    ) : (
                                        <div className="details-inner">
                                            <div className="d-flex justify-content-between mb-3">
                                                <p className="CardMainHeading">{courseData?.user_favorite_course?.course_category?.name}</p>
                                                {courseData?.user_favorite_course?.assign_trainer?.length > 0 && (
                                                    <div className="emt-user">
                                                        <span className="u-thumb">
                                                            <img src={courseData?.user_favorite_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="User" />
                                                        </span>
                                                        <span className="align-self-center">{courseData?.user_favorite_course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <h6 className="CardMainSubHeading">
                                                {courseData?.user_favorite_course?.name}
                                            </h6>
                                            <div className="LassonsMain">
                                                <ul className="LassonsUl">
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">{courseData.user_favorite_course.total_lession} {t('lessons')}</p>
                                                    </li>
                                                    <li className="dots" />
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">{courseData.user_favorite_course.duration}</p>
                                                    </li>
                                                    <li className="dots" />
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">
                                                            <strong>{courseData.user_favorite_course.validity}</strong> {t('daysValidity')}
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    <div className="emt-course-meta">
                                        <div className="LassonsCardFooter">
                                            <ul className="LassonsCardFooterUl">
                                                <li className="LassonsCardFooterLi">
                                                    <div className="rating">
                                                        <i className="fa fa-star" /> {courseData.user_favorite_course.avg_review}
                                                        <span>({courseData.user_favorite_course.total_review})</span>
                                                    </div>
                                                </li>
                                                <li className="LassonsCardFooterLi">
                                                    <div className="price">
                                                        <span>₹{courseData.user_favorite_course.price}</span>
                                                    </div>
                                                </li>
                                                <li className="LassonsCardFooterLi">
                                                    <div className="price" onClick={() => handleBookmark(courseData?.course_id)}>
                                                        {courseData?.is_favorite ? (
                                                            <i className="fa-solid fa-bookmark" />
                                                        ) : (
                                                            <i className="fa-regular fa-bookmark" />
                                                        )}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {courses.length === 0 && (
                        <h4 className='text-center mt-3 fw-light'>{t('emptyFavList')}</h4>
                    )}
                    {courses && courses.length > 0 && (
                        <ReactPaginate
                            className='pagination mt-4'
                            breakLabel="..."
                            nextLabel={`${t('next')} >`}
                            previousLabel={`< ${t('Previous')} `}
                            renderOnZeroPageCount={null}
                            onPageChange={handlePageClick}
                            pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};

export default FavouriteCourses;